module.exports = __webpack_public_path__ + "static/img/setting_2@2x.d5b6e148.png";